import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const depositPageStyles = {
    wrap: css`
        color: black;
        background-color: white;
        border-radius: 8px;
        padding: 20px;
        min-height: 800px;
    `,
    tabList: css`
        display: flex;
        align-items: center;
        margin-top: 50px;
    `,
    titleDeposit: css`
        color: '#282c35';
        margin-left: 50px;
        text-align: right;
        min-width: 220px;
    `,
    timeHandle: css`
        color: #e76946;
        margin-left: 20px;
    `,
    btnDeposit: css`
        color: #fff;
        font-weight: 500;
        background: #e96a46;
        background-image: linear-gradient(to bottom, #5b1313, #931f1f);
        display: inline-block;
        vertical-align: middle;
        border-radius: 3px;
        padding: 0 15px;
        height: 45px;
        line-height: 45px;
        margin-right: 0;
        font-size: 15px;
        width: 150px;
        -webkit-appearance: button;
        cursor: pointer;
        box-sizing: border-box;
        text-align: center;

        padding-block: 1px;
        padding-inline: 6px;
        border-width: 2px;
        border-style: outset;
        border-color: buttonborder;
        border-image: initial;
    `,
    viewDeposit: css`
        margin-left: 270px;
        display: flex;
        justify-content: center;
        margin-top: 30px;
    `,
    listTab: css`
        display: flex;
        justify-content: flex-start;
        margin-left: 28px;
        gap: 15px;
    `,
    tabItem: css`
        padding: 11px 25px;
        border-radius: 3px;
        font-size: 12px;
        background: linear-gradient(to bottom, #5dc07d 0%, #55bc75 50%, #4cb56b 100%);
        border: 1px solid #38a86c;
        min-width: 140px;
        text-align: center;
        color: white;

        cursor: pointer;

        &.active,
        &:hover {
            border: 1px solid #d2b252;
            background: linear-gradient(to bottom, #eccd66 0%, #ebc85e 50%, #e9c256 100%);
        }
    `,
    bankGroup: css`
        padding: 16px 0;
        border-bottom: 1px solid ${colors.borderTable};
    `,
    titleBankGroup: css`
        margin-bottom: 8px;
        font-weight: 400;
        span {
            color: ${colors.yellow};
            font-weight: 500;
        }
    `,
    bankList: css`
        display: flex;
        flex-wrap: wrap;
        gap: 50px;
        margin-left: 300px;
        margin-top: 50px;
        border-bottom: 1px solid #dcdcdc;
        padding-bottom: 40px;
    `,
    bankItem: css`
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        position: relative;
        .check {
            border: 1px solid #d0d0cf;
            width: 20px;
            height: 20px;
            border-radius: 100px;
            justify-content: center;
            align-items: center;
            display: flex;
        }
        .checked {
            width: 10px;
            height: 10px;
            background-color: #e76a4f;
            border-radius: 100px;
        }
    `,
    isMaintain: css`
        position: absolute;
        top: 0;
        right: 0;
        background: #b15050;
        border-radius: 4px;
        padding: 2px 4px;
        font-size: 12px;
        color: white;
    `,
    bankItemInner: css`
        background: ${colors.white};
        border-radius: 6px;
        padding: 4px 8px;
        position: relative;
        width: 170px;
        height: 120px;
        border: 1px solid #cacaca;

        .corner-check {
            --s: 25px;
            --c: #f15a24;
            position: absolute;
            top: 0;
            right: 0;
            width: var(--s);
            height: var(--s);
        }

        .corner-check::before {
            content: '';
            position: absolute;
            top: 0;
            right: 0;

            width: 0;
            height: 0;
            border-top: var(--s) solid var(--c);
            border-left: var(--s) solid transparent;
        }

        .corner-check::after {
            content: '';
            position: absolute;

            right: 4px;
            top: -1px;

            width: 6px;
            height: 10px;
            border-right: 2px solid #fff;
            border-bottom: 2px solid #fff;
            transform: rotate(45deg);
        }
    `,
    bankIcon: css`
        display: block;
        width: 100%;
        object-fit: contain;
    `,
    iconBankSelect: css`
        position: absolute;
        right: -2px;
        top: -2px;
        background-color: red;
    `,
    iframeDeposit: css`
        height: 700px;
        margin-top: 16px;
        iframe {
            border: none;
            width: 100%;
            height: 100%;
        }
    `,
    channelMaintain: css`
        font-size: 20px;
        text-align: center;
        padding: 40px 0;
        img {
            width: 150px;
        }
    `,
    noData: css`
        text-align: center;
        padding: 40px 0;
        font-size: 16px;
        color: #999;
        margin-left: 270px;
    `,
    btnDisabled: css`
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    `,
};
export default depositPageStyles;
